<form class="app-flex-form" (click)="debugForm(constructor.name)" (keydown)="(null)">
  @for (filter of filters(); track $index) {
    @if (currentFilterView() === filter.label && filter.column === ticketAdminFilterKey.Priority) {
      <mat-selection-list [formField]="formTree.priority">
        @for (opt of priorityOptions; track $index) {
          <mat-list-option [value]="opt.value" (click)="$event.stopPropagation()">
            {{ opt.label }}
          </mat-list-option>
        }
      </mat-selection-list>
    } @else if (currentFilterView() === filter.label && filter.column === ticketAdminFilterKey.Status) {
      <mat-selection-list [formField]="formTree.status">
        @for (opt of statusOptions; track $index) {
          <mat-list-option [value]="opt.value" (click)="$event.stopPropagation()">
            {{ opt.label }}
          </mat-list-option>
        }
      </mat-selection-list>
    }
  }
</form>
